
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.75 8.881L9.182 6.45l1.06 1.06L6 11.753 1.757 7.51l1.06-1.06L5.25 8.88V.5h1.5v8.381zM0 11h1.5v3h9v-3H12v3c0 .825-.675 1.5-1.5 1.5h-9C.675 15.5 0 14.778 0 14v-3z","fill":"#6D6D6D"}})])
          )
        }
      }
    